import { render, staticRenderFns } from "./Riskscheme.vue?vue&type=template&id=cfcf8fb8&scoped=true"
import script from "./Riskscheme.vue?vue&type=script&lang=js"
export * from "./Riskscheme.vue?vue&type=script&lang=js"
import style0 from "./Riskscheme.vue?vue&type=style&index=0&id=cfcf8fb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcf8fb8",
  null
  
)

export default component.exports